// app/redux/sagas/leaveBalanceSaga.js

import { call, put } from "redux-saga/effects";

import {
    setLeaveBalanceLoading,
    checkBalanceSuccess,
    checkBalanceFail,
    getUserSoldesSuccess,
    getUserSoldesFail,
    cancelLeaveRequestSuccess,
    cancelLeaveRequestFail,
    GET_ALL_COMPANY_SOLDES_REQUEST,
    getAllCompanySoldesSuccess,
    getAllCompanySoldesFail,
    exportSoldesExcelSuccess,
    exportSoldesExcelFail,
    importSoldesExcelSuccess,
    importSoldesExcelFail,
    UPDATE_SOLDE_REQUEST,
    updateSoldeSuccess,
    updateSoldeFail,
    GET_ALL_MOVEMENTS_REQUEST,
    getAllMovementsSuccess,
    getAllMovementsFail,
    GET_USER_MOVEMENTS_REQUEST,
    getUserMovementsSuccess,
    getUserMovementsFail,
    CHECK_BALANCE_REQUEST,
    GET_USER_SOLDES_REQUEST,
    EXPORT_SOLDES_EXCEL_REQUEST,
    IMPORT_SOLDES_EXCEL_REQUEST,
    CANCEL_LEAVE_REQUEST_REQUEST,
} from "../actions/leaveBalanceActions";
import { takeLatest } from "redux-saga/effects";

import { API_BASE_URL, getRequest, postRequest } from "../../../api";
import { GET_MY_LEAVE_REQUESTS_REQUEST, setLeaveRequestLoading } from "../actions/leaveRequestsActions";
import Swal from "sweetalert2";
import axios from "axios";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);
    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

// ===================== WORKERS =====================

export function* checkBalanceSaga(action) {
    const { userId, absenceTypeId, duree, companyId } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-balance/check?userId=${userId}&absenceTypeId=${absenceTypeId}&duree=${duree}&companyId=${companyId}`;
    const token = sessionStorage.getItem("token");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(checkBalanceSuccess(resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur vérification solde");
        yield put(checkBalanceFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* getUserSoldesSaga(action) {
    const { userId, companyId } = action.payload || {};
    if (!userId || userId === "0" || userId === 0 || !companyId || companyId === "0" || companyId === 0) {
        console.warn("Skipping getUserSoldesSaga due to invalid parameters:", { userId, companyId });
        return;
    }
    const url = `${API_BASE_URL}/api/soldes-conges/user/${userId}/available?companyId=${companyId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getUserSoldesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement soldes");
        yield put(getUserSoldesFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* cancelLeaveRequestSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { requestId } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/requests/${requestId}/cancel`;

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {},
            headers: { uid },
        });
        yield put(cancelLeaveRequestSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Demande annulée",
            text: "Votre solde a été restauré",
            timer: 1800,
            showConfirmButton: false,
        });
        yield put({ type: GET_MY_LEAVE_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur annulation demande");
        yield put(cancelLeaveRequestFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getAllCompanySoldesSaga() {
    const url = `${API_BASE_URL}/api/soldes-conges`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllCompanySoldesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement tous les soldes");
        yield put(getAllCompanySoldesFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

// ===================== EXPORT SOLDES EXCEL =====================
export function* exportSoldesExcelSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const url = `${API_BASE_URL}/api/soldes-conges/export-excel`;

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(axios.get, url, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
                uid,
            },
        });

        // Trigger file download
        const blob = new Blob([resp.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "soldes_conges.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        yield put(exportSoldesExcelSuccess());
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Export réussi",
            text: "Le fichier Excel a été téléchargé",
            timer: 1800,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur export Excel");
        yield put(exportSoldesExcelFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

// ===================== IMPORT SOLDES EXCEL =====================
export function* importSoldesExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const url = `${API_BASE_URL}/api/soldes-conges/import-excel`;
    const file = action.payload;

    const formData = new FormData();
    formData.append("file", file);

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(axios.post, url, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                uid,
                "Content-Type": "multipart/form-data",
            },
        });

        const result = resp.data;
        yield put(importSoldesExcelSuccess(result));

        const errList = result.errors || [];
        let html = `<b>${result.updated}</b> solde(s) mis à jour<br/><b>${result.skipped}</b> ligne(s) ignorée(s)`;
        if (errList.length > 0) {
            html += `<br/><br/><details><summary>Voir les erreurs</summary><ul style="text-align:left;font-size:12px;max-height:200px;overflow:auto">`;
            errList.forEach((e) => { html += `<li>${e}</li>`; });
            html += `</ul></details>`;
        }

        yield call([Swal, Swal.fire], {
            icon: result.skipped > 0 ? "warning" : "success",
            title: "Import terminé",
            html,
        });

        // Refresh the company soldes list
        yield put({ type: GET_ALL_COMPANY_SOLDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur import Excel");
        yield put(importSoldesExcelFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

// ===================== UPDATE SOLDE =====================
export function* updateSoldeSaga(action) {
    const { id, data } = action.payload;
    const url = `${API_BASE_URL}/api/soldes-conges/${id}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(axios.patch, url, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                uid,
            },
        });
        yield put(updateSoldeSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Solde mis à jour",
            text: "Le solde a été ajusté avec succès",
            timer: 1800,
            showConfirmButton: false,
        });
        // Refresh the lists
        yield put({ type: GET_ALL_COMPANY_SOLDES_REQUEST });
        yield put({ type: GET_ALL_MOVEMENTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour solde");
        yield put(updateSoldeFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

// ===================== MOVEMENTS HISTORY =====================
export function* getAllMovementsSaga() {
    const url = `${API_BASE_URL}/api/soldes-conges/history/all`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllMovementsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique détaillé");
        yield put(getAllMovementsFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* getUserMovementsSaga(action) {
    const { userId } = action.payload || {};
    if (!userId || userId === "0" || userId === 0) {
        console.warn("Skipping getUserMovementsSaga due to invalid userId:", userId);
        return;
    }
    const url = `${API_BASE_URL}/api/soldes-conges/history/user/${userId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getUserMovementsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique détaillé");
        yield put(getUserMovementsFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* watchLeaveBalanceSaga() {
    yield takeLatest(CHECK_BALANCE_REQUEST, checkBalanceSaga);
    yield takeLatest(GET_USER_SOLDES_REQUEST, getUserSoldesSaga);
    yield takeLatest(CANCEL_LEAVE_REQUEST_REQUEST, cancelLeaveRequestSaga);
    yield takeLatest(GET_ALL_COMPANY_SOLDES_REQUEST, getAllCompanySoldesSaga);
    yield takeLatest(EXPORT_SOLDES_EXCEL_REQUEST, exportSoldesExcelSaga);
    yield takeLatest(IMPORT_SOLDES_EXCEL_REQUEST, importSoldesExcelSaga);
    yield takeLatest(UPDATE_SOLDE_REQUEST, updateSoldeSaga);
    yield takeLatest(GET_ALL_MOVEMENTS_REQUEST, getAllMovementsSaga);
    yield takeLatest(GET_USER_MOVEMENTS_REQUEST, getUserMovementsSaga);
}